module.exports = __webpack_public_path__ + "img/120.cd9bfced.png";